import {
  Flex,
  chakra,
} from "@chakra-ui/react";

export const CenterFlex = chakra(Flex, {
  baseStyle: {
    justifyContent: "center",
    alignItems: "center",
  },
});
